// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body,
html {
	/* css-reset from AK doesn't have height 100% but tiny editor needs it */
	height: 100% !important;
}

.aui-popup.aui-dialog a,
.editor-container.adg3-editor a,
#content.edit.adg3-editor a,
.aui-popup.aui-dialog a:visited,
.editor-container.adg3-editor a:visited,
#content.edit.adg3-editor a:visited,
.aui-popup.aui-dialog a:focus,
.editor-container.adg3-editor a:focus,
#content.edit.adg3-editor a:focus,
.aui-popup.aui-dialog a:hover,
.editor-container.adg3-editor a:hover,
#content.edit.adg3-editor a:hover,
.aui-popup.aui-dialog a:active,
.editor-container.adg3-editor a:active,
#content.edit.adg3-editor a:active,
.aui-popup.aui-dialog a.blogHeading,
.editor-container.adg3-editor a.blogHeading,
#content.edit.adg3-editor a.blogHeading {
	color: var(--ds-link-pressed, #0052cc);
}

.aui-popup.aui-dialog .aui-button.aui-button-primary,
.editor-container.adg3-editor .aui-button.aui-button-primary,
#content.edit.adg3-editor .aui-button.aui-button-primary,
.aui-popup.aui-dialog .aui-button.aui-button-primary:visited,
.editor-container.adg3-editor .aui-button.aui-button-primary:visited,
#content.edit.adg3-editor .aui-button.aui-button-primary:visited {
	background: var(--ds-background-brand-bold, #0052cc);
}

.aui-popup.aui-dialog .aui-button.aui-button-primary:hover,
.editor-container.adg3-editor .aui-button.aui-button-primary:hover,
#content.edit.adg3-editor .aui-button.aui-button-primary:hover {
	background: var(--ds-background-brand-bold-hovered, #0065ff);
}

#com-atlassian-confluence .editor-container.adg3-editor .aui-icon-small:before,
#com-atlassian-confluence #content.edit.adg3-editor .aui-icon-small:before,
#com-atlassian-confluence .editor-container.adg3-editor .aui-icon-large:before,
#com-atlassian-confluence #content.edit.adg3-editor .aui-icon-large:before,
#com-atlassian-confluence .editor-container.adg3-editor .icon-close:before,
#com-atlassian-confluence #content.edit.adg3-editor .icon-close:before {
	color: var(--ds-icon, #405070);
	font-family: 'ADG3-Editor-Icons', 'Atlassian Icons' !important;
	font-size: 22px;
	font-weight: normal;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	font-style: normal;
	line-height: 1;
	position: absolute;
	text-indent: 0;
	speak: none;
	top: 0;
	margin-top: 0;
	margin-left: 1px;
}

#com-atlassian-confluence .editor-container.adg3-editor .aui-button:active .aui-icon-small:before,
#com-atlassian-confluence #content.edit.adg3-editor .aui-button:active .aui-icon-small:before,
#com-atlassian-confluence .editor-container.adg3-editor .aui-button:active .aui-icon-large:before,
#com-atlassian-confluence #content.edit.adg3-editor .aui-button:active .aui-icon-large:before,
#com-atlassian-confluence .editor-container.adg3-editor .aui-button:active .icon-close:before,
#com-atlassian-confluence #content.edit.adg3-editor .aui-button:active .icon-close:before {
	color: var(--ds-icon-brand, #0052cc);
}

#com-atlassian-confluence .editor-container.adg3-editor #rte-toolbar li.toolbar-item:active,
#com-atlassian-confluence #content.edit.adg3-editor #rte-toolbar li.toolbar-item:active {
	color: var(--ds-text-brand, #0052cc);
}

#com-atlassian-confluence .editor-container.adg3-editor #insert-menu-options,
#com-atlassian-confluence #content.edit.adg3-editor #insert-menu-options {
	overflow-y: auto;
	max-height: calc(80vh - 20px);
}

#com-atlassian-confluence .editor-container.adg3-editor .aui-toolbar2 .aui-dropdown,
#com-atlassian-confluence #content.edit.adg3-editor .aui-toolbar2 .aui-dropdown,
#com-atlassian-confluence .editor-container.adg3-editor .aui-dialog .aui-dropdown,
#com-atlassian-confluence #content.edit.adg3-editor .aui-dialog .aui-dropdown {
	background-color: var(--ds-background-input, #fff);
	border: 1px solid var(--ds-border, #ccc);
	border-radius: 5px;
	margin: 6px 0;
	padding: 3px 0;
	box-shadow: var(--ds-shadow-raised, 0 3px 6px rgba(0, 0, 0, 0.2));
}

#com-atlassian-confluence .editor-container.adg3-editor #savebar-container,
#com-atlassian-confluence #content.edit.adg3-editor #savebar-container {
	background-color: var(--ds-background-input, #ffffff);
}

#com-atlassian-confluence .editor-container.adg3-editor #savebar-container #rte-savebar,
#com-atlassian-confluence #content.edit.adg3-editor #savebar-container #rte-savebar {
	display: block;
	margin: 0;
	border-top: 1px solid var(--ds-border, #ccc);
	background-color: var(--ds-surface-sunken, #f5f5f5);
	padding: 5px 10px 13px 0;
	box-shadow: none;
}

#com-atlassian-confluence
	.editor-container.adg3-editor
	#savebar-container
	#rte-savebar
	#rte-spinner,
#com-atlassian-confluence #content.edit.adg3-editor #savebar-container #rte-savebar #rte-spinner {
	width: 16px;
	height: 18px;
	line-height: 20px;
	padding: 0;
	margin-top: 4px;
}

#com-atlassian-confluence
	.editor-container.adg3-editor
	#savebar-container
	#rte-savebar
	.minor-edit
	label,
#com-atlassian-confluence
	#content.edit.adg3-editor
	#savebar-container
	#rte-savebar
	.minor-edit
	label {
	color: var(--ds-text, #343c47);
	font-weight: normal;
}

#com-atlassian-confluence
	.editor-container.adg3-editor
	#savebar-container
	#rte-savebar
	#rte-button-cancel:not(.rte-button-cancel-shared-drafts),
#com-atlassian-confluence
	#content.edit.adg3-editor
	#savebar-container
	#rte-savebar
	#rte-button-cancel:not(.rte-button-cancel-shared-drafts),
#com-atlassian-confluence
	.editor-container.adg3-editor
	#savebar-container
	#rte-savebar
	#rte-button-revert,
#com-atlassian-confluence
	#content.edit.adg3-editor
	#savebar-container
	#rte-savebar
	#rte-button-revert {
	border: 0;
	padding: 4px 10px;
}

#com-atlassian-confluence
	.editor-container.adg3-editor
	#savebar-container
	#rte-savebar
	.toolbar-split,
#com-atlassian-confluence #content.edit.adg3-editor #savebar-container #rte-savebar .toolbar-split {
	line-height: 1;
	position: relative;
	margin-top: 6px;
}

#com-atlassian-confluence
	.editor-container.adg3-editor
	#savebar-container
	#rte-savebar
	.aui-button[value='cancel'],
#com-atlassian-confluence
	#content.edit.adg3-editor
	#savebar-container
	#rte-savebar
	.aui-button[value='cancel'],
#com-atlassian-confluence
	.editor-container.adg3-editor
	#savebar-container
	#rte-savebar
	#rte-button-edit,
#com-atlassian-confluence
	#content.edit.adg3-editor
	#savebar-container
	#rte-savebar
	#rte-button-edit {
	background: var(--ds-background-neutral, rgba(9, 30, 66, 0.04));
	color: var(--ds-text-subtle, #485160);
	border: none;
	min-width: initial;
}

#com-atlassian-confluence
	.editor-container.adg3-editor
	#savebar-container
	#rte-savebar
	.aui-button[value='cancel']:hover:not(.disabled),
#com-atlassian-confluence
	#content.edit.adg3-editor
	#savebar-container
	#rte-savebar
	.aui-button[value='cancel']:hover:not(.disabled),
#com-atlassian-confluence
	.editor-container.adg3-editor
	#savebar-container
	#rte-savebar
	#rte-button-edit:hover:not(.disabled),
#com-atlassian-confluence
	#content.edit.adg3-editor
	#savebar-container
	#rte-savebar
	#rte-button-edit:hover:not(.disabled) {
	background: var(--ds-background-neutral-hovered, rgba(9, 30, 66, 0.08));
}

#com-atlassian-confluence
	.editor-container.adg3-editor
	#savebar-container
	#rte-savebar
	.aui-button[value='cancel'].disabled,
#com-atlassian-confluence
	#content.edit.adg3-editor
	#savebar-container
	#rte-savebar
	.aui-button[value='cancel'].disabled,
#com-atlassian-confluence
	.editor-container.adg3-editor
	#savebar-container
	#rte-savebar
	#rte-button-edit.disabled,
#com-atlassian-confluence
	#content.edit.adg3-editor
	#savebar-container
	#rte-savebar
	#rte-button-edit.disabled {
	color: var(--ds-text-subtlest, #a5adba);
	cursor: not-allowed;
}

#com-atlassian-confluence
	.editor-container.adg3-editor
	#savebar-container
	#rte-savebar
	.status-indicator-icon.aui-icon-small:before,
#com-atlassian-confluence
	#content.edit.adg3-editor
	#savebar-container
	#rte-savebar
	.status-indicator-icon.aui-icon-small:before {
	font-size: 14px;
}

#com-atlassian-confluence .editor-container.adg3-editor #editor-precursor,
#com-atlassian-confluence #content.edit.adg3-editor #editor-precursor {
	margin-top: 88px;
}

#com-atlassian-confluence
	.editor-container.adg3-editor
	#editor-precursor
	#draft-status-lozenge
	span,
#com-atlassian-confluence #content.edit.adg3-editor #editor-precursor #draft-status-lozenge span {
	color: var(--ds-text-subtle, #333);
}

#com-atlassian-confluence
	.editor-container.adg3-editor
	#editor-precursor
	#rte-button-labels
	.icon:before,
#com-atlassian-confluence
	#content.edit.adg3-editor
	#editor-precursor
	#rte-button-labels
	.icon:before,
#com-atlassian-confluence
	.editor-container.adg3-editor
	#editor-precursor
	#rte-button-restrictions
	.icon:before,
#com-atlassian-confluence
	#content.edit.adg3-editor
	#editor-precursor
	#rte-button-restrictions
	.icon:before {
	color: var(--ds-icon, #42526e);
}

#com-atlassian-confluence
	.editor-container.adg3-editor
	#editor-precursor
	#rte-button-restrictions
	.icon.icon-red:before,
#com-atlassian-confluence
	#content.edit.adg3-editor
	#editor-precursor
	#rte-button-restrictions
	.icon.icon-red:before,
#com-atlassian-confluence
	.editor-container.adg3-editor
	#editor-precursor
	#rte-button-restrictions
	.icon.red:before,
#com-atlassian-confluence
	#content.edit.adg3-editor
	#editor-precursor
	#rte-button-restrictions
	.icon.red:before {
	color: var(--ds-icon-danger, #d04437);
}

#com-atlassian-confluence .editor-container.adg3-editor #editor-precursor #breadcrumbs,
#com-atlassian-confluence #content.edit.adg3-editor #editor-precursor #breadcrumbs {
	padding-left: 10px;
	display: inline-block;
	margin-top: 0;
	margin-bottom: 10px;
	/* placeholder styles, don't group them */
}

#com-atlassian-confluence
	.editor-container.adg3-editor
	#editor-precursor
	#content-title::-webkit-input-placeholder,
#com-atlassian-confluence
	#content.edit.adg3-editor
	#editor-precursor
	#content-title::-webkit-input-placeholder {
	color: var(--ds-text-disabled, rgba(23, 43, 77, 0.5));
}

#com-atlassian-confluence
	.editor-container.adg3-editor
	#editor-precursor
	#content-title:-moz-placeholder,
#com-atlassian-confluence
	#content.edit.adg3-editor
	#editor-precursor
	#content-title:-moz-placeholder {
	color: var(--ds-text-disabled, rgba(23, 43, 77, 0.5));
}

#com-atlassian-confluence
	.editor-container.adg3-editor
	#editor-precursor
	#content-title::-moz-placeholder,
#com-atlassian-confluence
	#content.edit.adg3-editor
	#editor-precursor
	#content-title::-moz-placeholder {
	color: var(--ds-text-disabled, rgba(23, 43, 77, 0.5));
}

#com-atlassian-confluence
	.editor-container.adg3-editor
	#editor-precursor
	#content-title:-ms-input-placeholder,
#com-atlassian-confluence
	#content.edit.adg3-editor
	#editor-precursor
	#content-title:-ms-input-placeholder {
	color: var(--ds-text-disabled, rgba(23, 43, 77, 0.5));
}

#com-atlassian-confluence
	.editor-container.adg3-editor
	#editor-precursor
	.aui-buttons
	.aui-button
	.aui-iconfont-unlocked:before,
#com-atlassian-confluence
	#content.edit.adg3-editor
	#editor-precursor
	.aui-buttons
	.aui-button
	.aui-iconfont-unlocked:before {
	content: '\\f1a9';
}

#com-atlassian-confluence
	.editor-container.adg3-editor
	#editor-precursor
	.aui-buttons
	.aui-button
	.aui-iconfont-locked:before,
#com-atlassian-confluence
	#content.edit.adg3-editor
	#editor-precursor
	.aui-buttons
	.aui-button
	.aui-iconfont-locked:before {
	content: '\\f179';
}

#com-atlassian-confluence .editor-container.adg3-editor #editor-precursor .aui-buttons .aui-button,
#com-atlassian-confluence #content.edit.adg3-editor #editor-precursor .aui-buttons .aui-button {
	margin-right: 2px;
}

#com-atlassian-confluence
	.editor-container.adg3-editor
	#editor-precursor
	.aui-buttons
	.aui-button
	.aui-iconfont-devtools-tag:before,
#com-atlassian-confluence
	#content.edit.adg3-editor
	#editor-precursor
	.aui-buttons
	.aui-button
	.aui-iconfont-devtools-tag:before,
#com-atlassian-confluence
	.editor-container.adg3-editor
	#editor-precursor
	.aui-buttons
	.aui-button
	.aui-iconfont-locked:before,
#com-atlassian-confluence
	#content.edit.adg3-editor
	#editor-precursor
	.aui-buttons
	.aui-button
	.aui-iconfont-locked:before,
#com-atlassian-confluence
	.editor-container.adg3-editor
	#editor-precursor
	.aui-buttons
	.aui-button
	.aui-iconfont-unlocked:before,
#com-atlassian-confluence
	#content.edit.adg3-editor
	#editor-precursor
	.aui-buttons
	.aui-button
	.aui-iconfont-unlocked:before,
#com-atlassian-confluence
	.editor-container.adg3-editor
	#editor-precursor
	.aui-buttons
	.aui-button
	.aui-iconfont-nav-children:before,
#com-atlassian-confluence
	#content.edit.adg3-editor
	#editor-precursor
	.aui-buttons
	.aui-button
	.aui-iconfont-nav-children:before {
	margin-top: -5px;
	margin-left: -3px;
	font-size: 24px;
}

#com-atlassian-confluence .editor-container.adg3-editor #rte-toolbar input,
#com-atlassian-confluence #content.edit.adg3-editor #rte-toolbar input,
#com-atlassian-confluence .editor-container.adg3-editor #rte-savebar input,
#com-atlassian-confluence #content.edit.adg3-editor #rte-savebar input,
#com-atlassian-confluence .editor-container.adg3-editor #update-page-restrictions-dialog input,
#com-atlassian-confluence #content.edit.adg3-editor #update-page-restrictions-dialog input {
	font-size: 14px;
	border-color: var(--ds-border, rgba(9, 30, 66, 0.13));
	background-color: var(--ds-background-input-hovered, #f4f5f7);
}

#com-atlassian-confluence
	.editor-container.adg3-editor
	#table-mode-picker.active
	a.toolbar-trigger.aui-button
	.dropdown-text,
#com-atlassian-confluence
	#content.edit.adg3-editor
	#table-mode-picker.active
	a.toolbar-trigger.aui-button
	.dropdown-text {
	color: var(--ds-background-input, #ffffff);
}

#com-atlassian-confluence
	.editor-container.adg3-editor
	#table-mode-picker
	a.toolbar-trigger.aui-button
	.dropdown-text,
#com-atlassian-confluence
	#content.edit.adg3-editor
	#table-mode-picker
	a.toolbar-trigger.aui-button
	.dropdown-text {
	padding: 0 10px;
	color: var(--ds-text-subtle, #405070);
	font-size: 14px;
	min-width: 70px;
}

#com-atlassian-confluence
	.editor-container.adg3-editor
	#table-mode-picker
	a.toolbar-trigger.aui-button:active
	.dropdown-text,
#com-atlassian-confluence
	#content.edit.adg3-editor
	#table-mode-picker
	a.toolbar-trigger.aui-button:active
	.dropdown-text {
	color: var(--ds-text-brand, #0052cc);
}

#com-atlassian-confluence
	.editor-container.adg3-editor
	#table-mode-picker.active
	.toolbar-trigger.aui-button,
#com-atlassian-confluence
	#content.edit.adg3-editor
	#table-mode-picker.active
	.toolbar-trigger.aui-button {
	border-color: var(--ds-border-bold, #ccc);
}

#com-atlassian-confluence
	.editor-container.adg3-editor
	#table-mode-picker.disabled
	a.toolbar-trigger.aui-button
	.dropdown-text,
#com-atlassian-confluence
	#content.edit.adg3-editor
	#table-mode-picker.disabled
	a.toolbar-trigger.aui-button
	.dropdown-text {
	color: var(--ds-text-subtle, #405070);
}
`, "",{"version":3,"sources":["webpack://./../confluence-editor/src/adg3-styles/global.css"],"names":[],"mappings":"AAAA;;CAEC,wEAAwE;CACxE,uBAAuB;AACxB;;AAEA;;;;;;;;;;;;;;;;;;CAkBC,sCAAsC;AACvC;;AAEA;;;;;;CAMC,oDAAoD;AACrD;;AAEA;;;CAGC,4DAA4D;AAC7D;;AAEA;;;;;;CAMC,8BAA8B;CAC9B,8DAA8D;CAC9D,eAAe;CACf,mBAAmB;CACnB,mCAAmC;CACnC,kCAAkC;CAClC,kBAAkB;CAClB,cAAc;CACd,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,MAAM;CACN,aAAa;CACb,gBAAgB;AACjB;;AAEA;;;;;;CAMC,oCAAoC;AACrC;;AAEA;;CAEC,oCAAoC;AACrC;;AAEA;;CAEC,gBAAgB;CAChB,6BAA6B;AAC9B;;AAEA;;;;CAIC,kDAAkD;CAClD,wCAAwC;CACxC,kBAAkB;CAClB,aAAa;CACb,cAAc;CACd,iEAAiE;AAClE;;AAEA;;CAEC,qDAAqD;AACtD;;AAEA;;CAEC,cAAc;CACd,SAAS;CACT,4CAA4C;CAC5C,mDAAmD;CACnD,wBAAwB;CACxB,gBAAgB;AACjB;;AAEA;;;;;;CAMC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,UAAU;CACV,eAAe;AAChB;;AAEA;;;;;;;;;;;;CAYC,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;;;;;;;;;;;;;;;;;;;;CAoBC,SAAS;CACT,iBAAiB;AAClB;;AAEA;;;;;;CAMC,cAAc;CACd,kBAAkB;CAClB,eAAe;AAChB;;AAEA;;;;;;;;;;;;;;;;;;;;CAoBC,+DAA+D;CAC/D,qCAAqC;CACrC,YAAY;CACZ,kBAAkB;AACnB;;AAEA;;;;;;;;;;;;;;;;;;;;CAoBC,uEAAuE;AACxE;;AAEA;;;;;;;;;;;;;;;;;;;;CAoBC,uCAAuC;CACvC,mBAAmB;AACpB;;AAEA;;;;;;;;;;CAUC,eAAe;AAChB;;AAEA;;CAEC,gBAAgB;AACjB;;AAEA;;;;;;CAMC,kCAAkC;AACnC;;AAEA;;;;;;;;;;;;;;;;;;;;CAoBC,8BAA8B;AAC/B;;AAEA;;;;;;;;;;;;;;;;;;;;CAoBC,qCAAqC;AACtC;;AAEA;;CAEC,kBAAkB;CAClB,qBAAqB;CACrB,aAAa;CACb,mBAAmB;CACnB,yCAAyC;AAC1C;;AAEA;;;;;;;;CAQC,qDAAqD;AACtD;;AAEA;;;;;;;;CAQC,qDAAqD;AACtD;;AAEA;;;;;;;;CAQC,qDAAqD;AACtD;;AAEA;;;;;;;;CAQC,qDAAqD;AACtD;;AAEA;;;;;;;;;;;;CAYC,gBAAgB;AACjB;;AAEA;;;;;;;;;;;;CAYC,gBAAgB;AACjB;;AAEA;;CAEC,iBAAiB;AAClB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAgDC,gBAAgB;CAChB,iBAAiB;CACjB,eAAe;AAChB;;AAEA;;;;;;CAMC,eAAe;CACf,qDAAqD;CACrD,6DAA6D;AAC9D;;AAEA;;;;;;;;;;CAUC,0CAA0C;AAC3C;;AAEA;;;;;;;;;;CAUC,eAAe;CACf,qCAAqC;CACrC,eAAe;CACf,eAAe;AAChB;;AAEA;;;;;;;;;;CAUC,oCAAoC;AACrC;;AAEA;;;;;;;;CAQC,yCAAyC;AAC1C;;AAEA;;;;;;;;;;CAUC,qCAAqC;AACtC","sourcesContent":["body,\nhtml {\n\t/* css-reset from AK doesn't have height 100% but tiny editor needs it */\n\theight: 100% !important;\n}\n\n.aui-popup.aui-dialog a,\n.editor-container.adg3-editor a,\n#content.edit.adg3-editor a,\n.aui-popup.aui-dialog a:visited,\n.editor-container.adg3-editor a:visited,\n#content.edit.adg3-editor a:visited,\n.aui-popup.aui-dialog a:focus,\n.editor-container.adg3-editor a:focus,\n#content.edit.adg3-editor a:focus,\n.aui-popup.aui-dialog a:hover,\n.editor-container.adg3-editor a:hover,\n#content.edit.adg3-editor a:hover,\n.aui-popup.aui-dialog a:active,\n.editor-container.adg3-editor a:active,\n#content.edit.adg3-editor a:active,\n.aui-popup.aui-dialog a.blogHeading,\n.editor-container.adg3-editor a.blogHeading,\n#content.edit.adg3-editor a.blogHeading {\n\tcolor: var(--ds-link-pressed, #0052cc);\n}\n\n.aui-popup.aui-dialog .aui-button.aui-button-primary,\n.editor-container.adg3-editor .aui-button.aui-button-primary,\n#content.edit.adg3-editor .aui-button.aui-button-primary,\n.aui-popup.aui-dialog .aui-button.aui-button-primary:visited,\n.editor-container.adg3-editor .aui-button.aui-button-primary:visited,\n#content.edit.adg3-editor .aui-button.aui-button-primary:visited {\n\tbackground: var(--ds-background-brand-bold, #0052cc);\n}\n\n.aui-popup.aui-dialog .aui-button.aui-button-primary:hover,\n.editor-container.adg3-editor .aui-button.aui-button-primary:hover,\n#content.edit.adg3-editor .aui-button.aui-button-primary:hover {\n\tbackground: var(--ds-background-brand-bold-hovered, #0065ff);\n}\n\n#com-atlassian-confluence .editor-container.adg3-editor .aui-icon-small:before,\n#com-atlassian-confluence #content.edit.adg3-editor .aui-icon-small:before,\n#com-atlassian-confluence .editor-container.adg3-editor .aui-icon-large:before,\n#com-atlassian-confluence #content.edit.adg3-editor .aui-icon-large:before,\n#com-atlassian-confluence .editor-container.adg3-editor .icon-close:before,\n#com-atlassian-confluence #content.edit.adg3-editor .icon-close:before {\n\tcolor: var(--ds-icon, #405070);\n\tfont-family: 'ADG3-Editor-Icons', 'Atlassian Icons' !important;\n\tfont-size: 22px;\n\tfont-weight: normal;\n\t-webkit-font-smoothing: antialiased;\n\t-moz-osx-font-smoothing: grayscale;\n\tfont-style: normal;\n\tline-height: 1;\n\tposition: absolute;\n\ttext-indent: 0;\n\tspeak: none;\n\ttop: 0;\n\tmargin-top: 0;\n\tmargin-left: 1px;\n}\n\n#com-atlassian-confluence .editor-container.adg3-editor .aui-button:active .aui-icon-small:before,\n#com-atlassian-confluence #content.edit.adg3-editor .aui-button:active .aui-icon-small:before,\n#com-atlassian-confluence .editor-container.adg3-editor .aui-button:active .aui-icon-large:before,\n#com-atlassian-confluence #content.edit.adg3-editor .aui-button:active .aui-icon-large:before,\n#com-atlassian-confluence .editor-container.adg3-editor .aui-button:active .icon-close:before,\n#com-atlassian-confluence #content.edit.adg3-editor .aui-button:active .icon-close:before {\n\tcolor: var(--ds-icon-brand, #0052cc);\n}\n\n#com-atlassian-confluence .editor-container.adg3-editor #rte-toolbar li.toolbar-item:active,\n#com-atlassian-confluence #content.edit.adg3-editor #rte-toolbar li.toolbar-item:active {\n\tcolor: var(--ds-text-brand, #0052cc);\n}\n\n#com-atlassian-confluence .editor-container.adg3-editor #insert-menu-options,\n#com-atlassian-confluence #content.edit.adg3-editor #insert-menu-options {\n\toverflow-y: auto;\n\tmax-height: calc(80vh - 20px);\n}\n\n#com-atlassian-confluence .editor-container.adg3-editor .aui-toolbar2 .aui-dropdown,\n#com-atlassian-confluence #content.edit.adg3-editor .aui-toolbar2 .aui-dropdown,\n#com-atlassian-confluence .editor-container.adg3-editor .aui-dialog .aui-dropdown,\n#com-atlassian-confluence #content.edit.adg3-editor .aui-dialog .aui-dropdown {\n\tbackground-color: var(--ds-background-input, #fff);\n\tborder: 1px solid var(--ds-border, #ccc);\n\tborder-radius: 5px;\n\tmargin: 6px 0;\n\tpadding: 3px 0;\n\tbox-shadow: var(--ds-shadow-raised, 0 3px 6px rgba(0, 0, 0, 0.2));\n}\n\n#com-atlassian-confluence .editor-container.adg3-editor #savebar-container,\n#com-atlassian-confluence #content.edit.adg3-editor #savebar-container {\n\tbackground-color: var(--ds-background-input, #ffffff);\n}\n\n#com-atlassian-confluence .editor-container.adg3-editor #savebar-container #rte-savebar,\n#com-atlassian-confluence #content.edit.adg3-editor #savebar-container #rte-savebar {\n\tdisplay: block;\n\tmargin: 0;\n\tborder-top: 1px solid var(--ds-border, #ccc);\n\tbackground-color: var(--ds-surface-sunken, #f5f5f5);\n\tpadding: 5px 10px 13px 0;\n\tbox-shadow: none;\n}\n\n#com-atlassian-confluence\n\t.editor-container.adg3-editor\n\t#savebar-container\n\t#rte-savebar\n\t#rte-spinner,\n#com-atlassian-confluence #content.edit.adg3-editor #savebar-container #rte-savebar #rte-spinner {\n\twidth: 16px;\n\theight: 18px;\n\tline-height: 20px;\n\tpadding: 0;\n\tmargin-top: 4px;\n}\n\n#com-atlassian-confluence\n\t.editor-container.adg3-editor\n\t#savebar-container\n\t#rte-savebar\n\t.minor-edit\n\tlabel,\n#com-atlassian-confluence\n\t#content.edit.adg3-editor\n\t#savebar-container\n\t#rte-savebar\n\t.minor-edit\n\tlabel {\n\tcolor: var(--ds-text, #343c47);\n\tfont-weight: normal;\n}\n\n#com-atlassian-confluence\n\t.editor-container.adg3-editor\n\t#savebar-container\n\t#rte-savebar\n\t#rte-button-cancel:not(.rte-button-cancel-shared-drafts),\n#com-atlassian-confluence\n\t#content.edit.adg3-editor\n\t#savebar-container\n\t#rte-savebar\n\t#rte-button-cancel:not(.rte-button-cancel-shared-drafts),\n#com-atlassian-confluence\n\t.editor-container.adg3-editor\n\t#savebar-container\n\t#rte-savebar\n\t#rte-button-revert,\n#com-atlassian-confluence\n\t#content.edit.adg3-editor\n\t#savebar-container\n\t#rte-savebar\n\t#rte-button-revert {\n\tborder: 0;\n\tpadding: 4px 10px;\n}\n\n#com-atlassian-confluence\n\t.editor-container.adg3-editor\n\t#savebar-container\n\t#rte-savebar\n\t.toolbar-split,\n#com-atlassian-confluence #content.edit.adg3-editor #savebar-container #rte-savebar .toolbar-split {\n\tline-height: 1;\n\tposition: relative;\n\tmargin-top: 6px;\n}\n\n#com-atlassian-confluence\n\t.editor-container.adg3-editor\n\t#savebar-container\n\t#rte-savebar\n\t.aui-button[value='cancel'],\n#com-atlassian-confluence\n\t#content.edit.adg3-editor\n\t#savebar-container\n\t#rte-savebar\n\t.aui-button[value='cancel'],\n#com-atlassian-confluence\n\t.editor-container.adg3-editor\n\t#savebar-container\n\t#rte-savebar\n\t#rte-button-edit,\n#com-atlassian-confluence\n\t#content.edit.adg3-editor\n\t#savebar-container\n\t#rte-savebar\n\t#rte-button-edit {\n\tbackground: var(--ds-background-neutral, rgba(9, 30, 66, 0.04));\n\tcolor: var(--ds-text-subtle, #485160);\n\tborder: none;\n\tmin-width: initial;\n}\n\n#com-atlassian-confluence\n\t.editor-container.adg3-editor\n\t#savebar-container\n\t#rte-savebar\n\t.aui-button[value='cancel']:hover:not(.disabled),\n#com-atlassian-confluence\n\t#content.edit.adg3-editor\n\t#savebar-container\n\t#rte-savebar\n\t.aui-button[value='cancel']:hover:not(.disabled),\n#com-atlassian-confluence\n\t.editor-container.adg3-editor\n\t#savebar-container\n\t#rte-savebar\n\t#rte-button-edit:hover:not(.disabled),\n#com-atlassian-confluence\n\t#content.edit.adg3-editor\n\t#savebar-container\n\t#rte-savebar\n\t#rte-button-edit:hover:not(.disabled) {\n\tbackground: var(--ds-background-neutral-hovered, rgba(9, 30, 66, 0.08));\n}\n\n#com-atlassian-confluence\n\t.editor-container.adg3-editor\n\t#savebar-container\n\t#rte-savebar\n\t.aui-button[value='cancel'].disabled,\n#com-atlassian-confluence\n\t#content.edit.adg3-editor\n\t#savebar-container\n\t#rte-savebar\n\t.aui-button[value='cancel'].disabled,\n#com-atlassian-confluence\n\t.editor-container.adg3-editor\n\t#savebar-container\n\t#rte-savebar\n\t#rte-button-edit.disabled,\n#com-atlassian-confluence\n\t#content.edit.adg3-editor\n\t#savebar-container\n\t#rte-savebar\n\t#rte-button-edit.disabled {\n\tcolor: var(--ds-text-subtlest, #a5adba);\n\tcursor: not-allowed;\n}\n\n#com-atlassian-confluence\n\t.editor-container.adg3-editor\n\t#savebar-container\n\t#rte-savebar\n\t.status-indicator-icon.aui-icon-small:before,\n#com-atlassian-confluence\n\t#content.edit.adg3-editor\n\t#savebar-container\n\t#rte-savebar\n\t.status-indicator-icon.aui-icon-small:before {\n\tfont-size: 14px;\n}\n\n#com-atlassian-confluence .editor-container.adg3-editor #editor-precursor,\n#com-atlassian-confluence #content.edit.adg3-editor #editor-precursor {\n\tmargin-top: 88px;\n}\n\n#com-atlassian-confluence\n\t.editor-container.adg3-editor\n\t#editor-precursor\n\t#draft-status-lozenge\n\tspan,\n#com-atlassian-confluence #content.edit.adg3-editor #editor-precursor #draft-status-lozenge span {\n\tcolor: var(--ds-text-subtle, #333);\n}\n\n#com-atlassian-confluence\n\t.editor-container.adg3-editor\n\t#editor-precursor\n\t#rte-button-labels\n\t.icon:before,\n#com-atlassian-confluence\n\t#content.edit.adg3-editor\n\t#editor-precursor\n\t#rte-button-labels\n\t.icon:before,\n#com-atlassian-confluence\n\t.editor-container.adg3-editor\n\t#editor-precursor\n\t#rte-button-restrictions\n\t.icon:before,\n#com-atlassian-confluence\n\t#content.edit.adg3-editor\n\t#editor-precursor\n\t#rte-button-restrictions\n\t.icon:before {\n\tcolor: var(--ds-icon, #42526e);\n}\n\n#com-atlassian-confluence\n\t.editor-container.adg3-editor\n\t#editor-precursor\n\t#rte-button-restrictions\n\t.icon.icon-red:before,\n#com-atlassian-confluence\n\t#content.edit.adg3-editor\n\t#editor-precursor\n\t#rte-button-restrictions\n\t.icon.icon-red:before,\n#com-atlassian-confluence\n\t.editor-container.adg3-editor\n\t#editor-precursor\n\t#rte-button-restrictions\n\t.icon.red:before,\n#com-atlassian-confluence\n\t#content.edit.adg3-editor\n\t#editor-precursor\n\t#rte-button-restrictions\n\t.icon.red:before {\n\tcolor: var(--ds-icon-danger, #d04437);\n}\n\n#com-atlassian-confluence .editor-container.adg3-editor #editor-precursor #breadcrumbs,\n#com-atlassian-confluence #content.edit.adg3-editor #editor-precursor #breadcrumbs {\n\tpadding-left: 10px;\n\tdisplay: inline-block;\n\tmargin-top: 0;\n\tmargin-bottom: 10px;\n\t/* placeholder styles, don't group them */\n}\n\n#com-atlassian-confluence\n\t.editor-container.adg3-editor\n\t#editor-precursor\n\t#content-title::-webkit-input-placeholder,\n#com-atlassian-confluence\n\t#content.edit.adg3-editor\n\t#editor-precursor\n\t#content-title::-webkit-input-placeholder {\n\tcolor: var(--ds-text-disabled, rgba(23, 43, 77, 0.5));\n}\n\n#com-atlassian-confluence\n\t.editor-container.adg3-editor\n\t#editor-precursor\n\t#content-title:-moz-placeholder,\n#com-atlassian-confluence\n\t#content.edit.adg3-editor\n\t#editor-precursor\n\t#content-title:-moz-placeholder {\n\tcolor: var(--ds-text-disabled, rgba(23, 43, 77, 0.5));\n}\n\n#com-atlassian-confluence\n\t.editor-container.adg3-editor\n\t#editor-precursor\n\t#content-title::-moz-placeholder,\n#com-atlassian-confluence\n\t#content.edit.adg3-editor\n\t#editor-precursor\n\t#content-title::-moz-placeholder {\n\tcolor: var(--ds-text-disabled, rgba(23, 43, 77, 0.5));\n}\n\n#com-atlassian-confluence\n\t.editor-container.adg3-editor\n\t#editor-precursor\n\t#content-title:-ms-input-placeholder,\n#com-atlassian-confluence\n\t#content.edit.adg3-editor\n\t#editor-precursor\n\t#content-title:-ms-input-placeholder {\n\tcolor: var(--ds-text-disabled, rgba(23, 43, 77, 0.5));\n}\n\n#com-atlassian-confluence\n\t.editor-container.adg3-editor\n\t#editor-precursor\n\t.aui-buttons\n\t.aui-button\n\t.aui-iconfont-unlocked:before,\n#com-atlassian-confluence\n\t#content.edit.adg3-editor\n\t#editor-precursor\n\t.aui-buttons\n\t.aui-button\n\t.aui-iconfont-unlocked:before {\n\tcontent: '\\f1a9';\n}\n\n#com-atlassian-confluence\n\t.editor-container.adg3-editor\n\t#editor-precursor\n\t.aui-buttons\n\t.aui-button\n\t.aui-iconfont-locked:before,\n#com-atlassian-confluence\n\t#content.edit.adg3-editor\n\t#editor-precursor\n\t.aui-buttons\n\t.aui-button\n\t.aui-iconfont-locked:before {\n\tcontent: '\\f179';\n}\n\n#com-atlassian-confluence .editor-container.adg3-editor #editor-precursor .aui-buttons .aui-button,\n#com-atlassian-confluence #content.edit.adg3-editor #editor-precursor .aui-buttons .aui-button {\n\tmargin-right: 2px;\n}\n\n#com-atlassian-confluence\n\t.editor-container.adg3-editor\n\t#editor-precursor\n\t.aui-buttons\n\t.aui-button\n\t.aui-iconfont-devtools-tag:before,\n#com-atlassian-confluence\n\t#content.edit.adg3-editor\n\t#editor-precursor\n\t.aui-buttons\n\t.aui-button\n\t.aui-iconfont-devtools-tag:before,\n#com-atlassian-confluence\n\t.editor-container.adg3-editor\n\t#editor-precursor\n\t.aui-buttons\n\t.aui-button\n\t.aui-iconfont-locked:before,\n#com-atlassian-confluence\n\t#content.edit.adg3-editor\n\t#editor-precursor\n\t.aui-buttons\n\t.aui-button\n\t.aui-iconfont-locked:before,\n#com-atlassian-confluence\n\t.editor-container.adg3-editor\n\t#editor-precursor\n\t.aui-buttons\n\t.aui-button\n\t.aui-iconfont-unlocked:before,\n#com-atlassian-confluence\n\t#content.edit.adg3-editor\n\t#editor-precursor\n\t.aui-buttons\n\t.aui-button\n\t.aui-iconfont-unlocked:before,\n#com-atlassian-confluence\n\t.editor-container.adg3-editor\n\t#editor-precursor\n\t.aui-buttons\n\t.aui-button\n\t.aui-iconfont-nav-children:before,\n#com-atlassian-confluence\n\t#content.edit.adg3-editor\n\t#editor-precursor\n\t.aui-buttons\n\t.aui-button\n\t.aui-iconfont-nav-children:before {\n\tmargin-top: -5px;\n\tmargin-left: -3px;\n\tfont-size: 24px;\n}\n\n#com-atlassian-confluence .editor-container.adg3-editor #rte-toolbar input,\n#com-atlassian-confluence #content.edit.adg3-editor #rte-toolbar input,\n#com-atlassian-confluence .editor-container.adg3-editor #rte-savebar input,\n#com-atlassian-confluence #content.edit.adg3-editor #rte-savebar input,\n#com-atlassian-confluence .editor-container.adg3-editor #update-page-restrictions-dialog input,\n#com-atlassian-confluence #content.edit.adg3-editor #update-page-restrictions-dialog input {\n\tfont-size: 14px;\n\tborder-color: var(--ds-border, rgba(9, 30, 66, 0.13));\n\tbackground-color: var(--ds-background-input-hovered, #f4f5f7);\n}\n\n#com-atlassian-confluence\n\t.editor-container.adg3-editor\n\t#table-mode-picker.active\n\ta.toolbar-trigger.aui-button\n\t.dropdown-text,\n#com-atlassian-confluence\n\t#content.edit.adg3-editor\n\t#table-mode-picker.active\n\ta.toolbar-trigger.aui-button\n\t.dropdown-text {\n\tcolor: var(--ds-background-input, #ffffff);\n}\n\n#com-atlassian-confluence\n\t.editor-container.adg3-editor\n\t#table-mode-picker\n\ta.toolbar-trigger.aui-button\n\t.dropdown-text,\n#com-atlassian-confluence\n\t#content.edit.adg3-editor\n\t#table-mode-picker\n\ta.toolbar-trigger.aui-button\n\t.dropdown-text {\n\tpadding: 0 10px;\n\tcolor: var(--ds-text-subtle, #405070);\n\tfont-size: 14px;\n\tmin-width: 70px;\n}\n\n#com-atlassian-confluence\n\t.editor-container.adg3-editor\n\t#table-mode-picker\n\ta.toolbar-trigger.aui-button:active\n\t.dropdown-text,\n#com-atlassian-confluence\n\t#content.edit.adg3-editor\n\t#table-mode-picker\n\ta.toolbar-trigger.aui-button:active\n\t.dropdown-text {\n\tcolor: var(--ds-text-brand, #0052cc);\n}\n\n#com-atlassian-confluence\n\t.editor-container.adg3-editor\n\t#table-mode-picker.active\n\t.toolbar-trigger.aui-button,\n#com-atlassian-confluence\n\t#content.edit.adg3-editor\n\t#table-mode-picker.active\n\t.toolbar-trigger.aui-button {\n\tborder-color: var(--ds-border-bold, #ccc);\n}\n\n#com-atlassian-confluence\n\t.editor-container.adg3-editor\n\t#table-mode-picker.disabled\n\ta.toolbar-trigger.aui-button\n\t.dropdown-text,\n#com-atlassian-confluence\n\t#content.edit.adg3-editor\n\t#table-mode-picker.disabled\n\ta.toolbar-trigger.aui-button\n\t.dropdown-text {\n\tcolor: var(--ds-text-subtle, #405070);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
